const Index = () => import('./index.vue');
const CreatePage = () => import('./_pages/create.vue');
const ViewPage = () => import('./_pages/view.vue');

export default [
    {
        path: '/outsourced-sales',
        component: Index
    },
    {
        path: '/outsourced-sales/create',
        component: CreatePage
    },
    {
        path: '/outsourced-sales/:id',
        component: ViewPage
    }
]